class PdpUpsellSingleAddOnItem extends HTMLElement {
  constructor() {
    super();
  }

  // Callback invoked when the element is inserted into the DOM.
  connectedCallback() {
    this.initItems();
    this.initComponents();
  }

  // Callback invoked when the element is removed from the DOM.
  disconnectedCallback() {
    this.checkbox.removeEventListener(
      "input",
      this.checkboxEventHandler.bind(this)
    );

    this.removeEventListener(
      "pdp-upsell-quantity-control-quantity-change",
      this.quantityEventHandler.bind(this)
    );
  }

  // Initializes the item elements.
  initItems() {
    this.section = this;
    this.checkbox = this.section.querySelector(`input[type="checkbox"]`);

    this.checkbox.addEventListener(
      "input",
      this.checkboxEventHandler.bind(this)
    );
  }

  // Initializes the component elements.
  initComponents() {
    this.quantityControllers = this.querySelector(
      "pdp-upsell-quantity-controls"
    );

    this.addEventListener(
      "pdp-upsell-quantity-control-quantity-change",
      this.quantityEventHandler.bind(this)
    );
  }

  // Event handler for checkbox input.
  checkboxEventHandler() {
    this.dispatchEvent(
      new CustomEvent("pdp-upsell-single-add-on-item-change", {
        bubbles: true,
      })
    );
  }

  // Event handler for quantity change.
  quantityEventHandler() {
    this.dispatchEvent(
      new CustomEvent("pdp-upsell-single-add-on-item-change", {
        bubbles: true,
      })
    );
  }
}
customElements.define(
  "pdp-upsell-single-add-on-item",
  PdpUpsellSingleAddOnItem
);
